// EAN-8, UPC-A (12), EAN-13, GTIN-14
export const hasBarcodeFormat = (raw) => /^(\d{8}|\d{12}|\d{13}|\d{14})$/.test(String(raw || "").trim());

export const hasValidCheckDigit = (raw) => {
  const code = String(raw || "").trim();
  if (!hasBarcodeFormat(code)) return false;
  const digits = code.split("").map(Number);
  const check = digits.pop();
  const sum = digits.reverse().reduce((s, d, i) => s + d * (i % 2 === 0 ? 3 : 1), 0);
  return (10 - (sum % 10)) % 10 === check;
};
